import * as Yup from "yup"

// grundformuläret customer utan departments,users
export const customerValidationSchema = (t) =>
  Yup.object().shape({
    name: Yup.string()
      .required(t("global.name_is_required", "Name is required"))
      .min(2, t("global.name_must_be_atleast_two_characters", "Name needs to be at least 2 characters long")),
    organisationNumber: Yup.number().typeError(
      t("global.organization_number_must_be_a_number", "Organization number needs to be a number")
    ),
    streetAddress: Yup.string(),
    postalCode: Yup.number().typeError(
      t("global.postnumber_number_must_be_a_number", "Postal code needs to be a number")
    ),
    cityAddress: Yup.string()
  })
